import FlashcardComponent from '@views/quizzes/flashcards/show';
import FlashcardV2Component from '@views/quizzes/flashcards-v2/show';
import ProgressFlashcardComponent from '@views/progress/questions/show';
import CategoryFlashcardV2Component from '@views/categories/flashcards-v2/show';

export default [
  {
    path: '/scenarios/:categoryTypeId?',
    name: 'scenarios#index',
    component: () => import('@views/scenarios/index'),
    meta: {
      header: true,
      masteryHeader: true,
      masteryFooter: true,
    },
  },
  {
    path: '/scenarios/:categoryTypeId?/category/:categoryId?',
    name: 'scenarios#category',
    component: () => import('@views/scenarios/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/scenarios/:categoryId/flashcards/:flashcardId?',
    name: 'scenarios#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/scenarios/:categoryId/flashcards-v2/:flashcardId?',
    name: 'scenarios#flashcard-v2',
    component: FlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/scenarios/:categoryId/results',
    name: 'scenarios#results',
    component: () => import('@views/quizzes/results'),
    meta: {
      header: true,
    },
  },
  {
    path: '/scenarios/:categoryId/results/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'scenarios#results#question',
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/scenarios/:categoryId/review/:flashcardId?',
    name: 'scenarios#review',
    component: CategoryFlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
];
